import { Text, View } from '../../other/html'
import Space from 'src/components/atoms/Space'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatPrice } from '../../../helpers/formatPrice'
import { useDispatch } from 'react-redux'
import { SHOW_AUCTION_CONTRACT_MODAL, SHOW_BUY_NOW_MODAL } from 'dealer-reducers'
import Button from 'src/components/atoms/Button'
import TextNew from 'src/components/atoms/TextNew'
interface Props {
  highestBet: number
  yourHighest: number
  buyNowPrice: number
  minimalPrice: number
  offerId: number
}

const SellSection = ({ highestBet, yourHighest, buyNowPrice, offerId, minimalPrice }: Props): JSX.Element => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const yourBetIsHighest = yourHighest === highestBet
  return (
    <>
      <Space y={6} />
      <View className="flex justify-between">
        <View className="flex items-start">
          <View>
            <Text fontSize="l" fontWeight="Medium">
              {t('single_offer.your_highest')}
            </Text>
          </View>
          <Space x={2} />
          <View>
            <Text
              data-testid="your-highest-price"
              fontSize="l"
              fontWeight="SemiBold"
              color={yourBetIsHighest ? 'groupBlue' : 'errorRed'}>
              {yourHighest > 0 ? `€ ${formatPrice(yourHighest)}` : '-'}
            </Text>
          </View>
        </View>
        <View className="flex items-center">
          <View>
            <Text fontSize="l" fontWeight="Medium">
              {t('single_offer.buy_now')}
            </Text>
            <Space y={1} />
          </View>
          <Space x={2} />
          <View>
            <Text fontSize="l" fontWeight="SemiBold" color="groupBlue">
              {buyNowPrice > 0 ? `€ ${formatPrice(buyNowPrice)}` : '-'}
            </Text>
            <Space y={1} />
          </View>
        </View>
      </View>
      <Space y={4} />
      <View className="flex justify-center items-center">
        <Button
          variant="small"
          onClick={() => dispatch(SHOW_AUCTION_CONTRACT_MODAL({ offerId, highestBet, fullHeight: true }))}
          color="yellow"
          customStyles="!py-3 !rounded-[10px] !w-[144px] !text-xl text-center">
          <TextNew className="text-xl text-white font-SemiBold">{t('single_offer.place_an_offer')}</TextNew>
        </Button>
        {buyNowPrice > 0 && (
          <>
            <Space x={2} />
            <Button
              variant="small"
              onClick={() => dispatch(SHOW_BUY_NOW_MODAL({ offerId, highestBet, buyNowPrice, fullHeight: true }))}
              customStyles="!p-3 !rounded-[10px] !w-[144px] text-center">
              <TextNew className="text-xl text-white font-SemiBold">{t('single_offer.buy_now_button')}</TextNew>
            </Button>
          </>
        )}
      </View>
    </>
  )
}

export default SellSection
